var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { cssClassMap } from '../../constants/SportCssMap';
import * as FactorStatus from '../../constants/FactorStatus';
var messages = defineMessages({
    stake_amount: {
        id: 'briefcase_stake_amount',
        defaultMessage: 'Сумма'
    },
    stake_state_1: {
        id: 'stake_state_1',
        defaultMessage: 'Активна'
    },
    stake_state_2: {
        id: 'stake_state_2',
        defaultMessage: 'Выигрыш'
    },
    stake_state_3: {
        id: 'stake_state_3',
        defaultMessage: 'Проигрыш'
    },
    stake_state_4: {
        id: 'stake_state_4',
        defaultMessage: 'Возврат'
    },
    stake_state_5: {
        id: 'stake_state_5',
        defaultMessage: 'Продана'
    },
    stake_state_10: {
        id: 'stake_state_10',
        defaultMessage: 'Возврат'
    },
    stake_state_11: {
        id: 'stake_state_1',
        defaultMessage: 'Активна'
    },
    stake_state_0: {
        id: 'stake_state_0',
        defaultMessage: 'Неизвестна'
    },
    freebet_simple_hint: {
        id: 'member-area.freebet_simple_hint',
        defaultMessage: 'Freebet'
    },
    bet_type: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар'
    }
});
function getFactorStatusClassName(status) {
    switch (status) {
        case FactorStatus.WON:
            return 'win';
        case FactorStatus.ACTIVE:
        case 11:
            return 'active';
        case FactorStatus.LOST:
            return 'lost';
        default:
            return 'refund';
    }
}
var Single = /** @class */ (function (_super) {
    __extends(Single, _super);
    function Single() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            descriptionToggled: false
        };
        _this.onClick = function () {
            _this.setState({
                descriptionToggled: !_this.state.descriptionToggled
            });
        };
        return _this;
    }
    Single.prototype.render = function () {
        var betsDataItem = this.props.betsDataItem;
        var descriptionToggled = this.state.descriptionToggled;
        var factor = betsDataItem.Factors[0];
        var singleStatus = factor.FactorState;
        var isFreebet = betsDataItem.IsFreebet;
        var sportCssName = cssClassMap[factor.SportClassId];
        var eventName = factor.EventNotice ? factor.EventName + ' (' + factor.EventNotice + ')' : factor.EventName;
        var outcomeNameCls = descriptionToggled ? ' history__bet__outcome__name--toggled' : '';
        var messageStatus = messages['stake_state_' + singleStatus] || messages.stake_state_0;
        return (_jsxs("div", __assign({ className: "history__bet ".concat(sportCssName) }, { children: [_jsxs("div", __assign({ className: "history__bet__head ".concat(sportCssName) }, { children: [_jsxs("div", __assign({ className: 'history__bet__head__left' }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), _jsx(FormattedMessage, __assign({}, messages.bet_type)), "\u2116 ", betsDataItem.StakeId] })), _jsx("div", __assign({ className: 'history__bet__head__right' }, { children: moment(betsDataItem.StakeReceptionDate).format('DD.MM.YYYY, HH:mm') }))] })), _jsxs("div", __assign({ className: 'history__bet__body' }, { children: [_jsxs("div", __assign({ className: 'history__bet__row history__bet__outcome' }, { children: [_jsxs("div", __assign({ className: "history__bet__body__left history__bet__outcome__name".concat(outcomeNameCls), onClick: this.onClick }, { children: [_jsx("strong", { children: factor.FullDescription }), factor.IsLive && _jsx("span", __assign({ className: 'live' }, { children: "Live" }))] })), _jsx("div", __assign({ className: 'history__bet__body__right history__bet__outcome__rate' }, { children: factor.FactorValue.toFixed(2) }))] })), _jsxs("div", __assign({ className: 'history__bet__row history__bet__bet-amount' }, { children: [_jsxs("div", __assign({ className: 'history__bet__body__left' }, { children: [_jsx(FormattedMessage, __assign({}, messages.stake_amount)), ":\u00A0", _jsxs("strong", { children: [betsDataItem.StakeAmount.toFixed(2), " "] }), isFreebet &&
                                            _jsx(FormattedMessage, __assign({}, messages.freebet_simple_hint, { children: function (m) { return _jsx("span", __assign({ className: 'live' }, { children: m })); } }))] })), _jsx("div", __assign({ className: 'history__bet__body__right' }, { children: _jsxs("div", __assign({ className: "history__bet__bet-amount__status history__bet__bet-amount__status--".concat(getFactorStatusClassName(singleStatus)) }, { children: [_jsx(FormattedMessage, __assign({}, messageStatus)), betsDataItem.StakePaymentAmount > 0 && _jsx("strong", { children: betsDataItem.StakePaymentAmount })] })) }))] })), descriptionToggled && _jsxs("div", __assign({ className: 'history__bet__description' }, { children: [factor.LeagueName, " ", eventName, _jsx("div", { children: moment(factor.StartDate).format('DD.MM.YYYY, HH:mm') })] }))] }))] })));
    };
    return Single;
}(PureComponent));
;
Single.propTypes = {
    betsDataItem: PropTypes.object.isRequired,
};
export default Single;



// WEBPACK FOOTER //
// ./src/components/betting-history/Single.jsx